module.exports = __webpack_public_path__ + "img/interruptores_de_limite.d6541707.jpg";